import { format } from "date-fns";

export default (rawDate) => {
  return format(new Date(rawDate), "dd MMMM y | h:mm a");
};
